// extracted by mini-css-extract-plugin
module.exports = {"center":"Loader_center__3DNW3","ldsRing":"Loader_ldsRing__3001F"};